/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {
    PieceSettingsNameItem_Piece$data
} from "ui/feature/piece-settings/__generated__/PieceSettingsNameItem_Piece.graphql";
import ChangeMusicPieceName from "mutation/ChangeMusicPieceName";
import PieceSettingsDebouncedItem from "ui/feature/piece-settings/PieceSettingsDebouncedItem";
import Header2 from "ui/kit/typography/Header2";

interface Props {
    piece: PieceSettingsNameItem_Piece$data
}

const PieceSettingsNameItem: React.FC<Props> = ({piece}) => {

    const [currentPieceName, setCurrentPieceName] = React.useState<string>(piece.name || "")

    const performSave = React.useCallback(async (val: string) => {
        if (val === currentPieceName) {
            // already using this
            return;
        }
        const response = await ChangeMusicPieceName(piece.id, val)
        setCurrentPieceName(response.music_change_piece_name.piece.name || "")
    }, [currentPieceName, piece.id])

    return (<div>
        <Header2>Name</Header2>
        <PieceSettingsDebouncedItem initialText={currentPieceName} performSave={performSave}/>
    </div>)
}

export default createFragmentContainer(PieceSettingsNameItem, {
    piece: graphql`
    fragment PieceSettingsNameItem_Piece on MusicPiece {
        id
        name
    }
    `
});